import React from "react";
import { useHistory } from "react-router-dom";
import {checkCookie} from 'ubs-framework/v2/common/function';
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import Layout from "../../../components/layout/Layout";
export const Error404 = () => {
    const history = useHistory();
    const handleRedirect = () => {
        if (checkCookie('ubs_token')) {
            history.push('/workspace');
        } else {
            history.push("/login");
        }
    };

    const ErrorContent = () => (
        <div className="u_account-form">
            {!checkCookie('ubs_token') && <Commonrightcircle />}
            <div className="u_error-page u_mb-30">
                <img src="/images/images/error_404.png" alt="OOPS! PAGE NOT FOUND" />
                <h2 className="u_mb-30">OOPS! PAGE NOT FOUND</h2>
                <button
                    type="button"
                    onClick={handleRedirect}
                    className="u_account-btn u_w-full u_cp"
                >
                    {checkCookie('ubs_token') ? "Go to Workspace" : "Login"}
                </button>
            </div>
        </div>
    );

    return (
        <>
            {checkCookie('ubs_token') ? (
                    <ErrorContent />
            ) : (
                <Layout>
                    <ErrorContent />
                </Layout>
            )}
        </>
    );
};

export default Error404;
